<script>
export default {
  props: {
    invitationLoading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    loading: false,
    step: 1,
    selectedMethod: 'email',
  }),
  methods: {
    selectMethod(method) {
      this.$emit('selectingMethod', method)
    }
  }
}
</script>
<template>
  <v-stepper-content step="1">
    <v-card-text class="pb-0">
      <v-row>
        <v-col>{{ $t('component.profile.administrationManagement.invite.method') }}</v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row class="mb-5 mt-5">
        <v-col align="center">
          <v-card
            class="invitation-selection-button pt-5 pb-5"
            color="secondary"
            @click="selectMethod('email')">
            <v-card-title class="d-flex justify-center">
              <v-icon color="white">mdi-mail</v-icon>
            </v-card-title>
            <v-card-text class="white--text">
              <h3>{{ $t('global.email') }}</h3>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="2">
          <v-card-text align="center" style="position:relative;top:25%;">
            {{ $t('global.or') }}
          </v-card-text>
        </v-col>
        <v-col align="center">
          <v-card
            color="secondary"
            class="invitation-selection-button pt-5 pb-5"
            @click="selectMethod('csv')">
            <v-card-title class="d-flex justify-center">
              <v-icon color="white">mdi-file</v-icon>
            </v-card-title>
            <v-card-text class="white--text">
              <h3>{{ $t('component.profile.administrationManagement.csv.upload') }}</h3>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-stepper-content>
</template>
<style scoped>
.v-card.invitation-selection-button:hover {
  background: #002c38 !important;
}
</style>
